export const initialChangeTrue = {
    vertical: true,
    clasificacion: true,
    categoria: true,
    subcategoria: true,
    segmento: true,
    subsegmento: true,
    marca: true,
    familia: true,
    acreedor: true,
    grupo_compras: true,
    indicador_abc: true,
    estado: true,
    gnombre: true,
    pnombre: true,
}

export const initialChangeFalse = {
    vertical: false,
    clasificacion: false,
    categoria: false,
    subcategoria: false,
    segmento: false,
    subsegmento: false,
    marca: false,
    familia: false,
    acreedor: false,
    grupo_compras: false,
    indicador_abc: false,
    estado: false,
    gnombre: false,
    pnombre: false,
}

export const initialForm = {
    marca: [],
    estado: [],
    vertical: [],
    categoria: [],
    clasificacion: [],
    subcategoria: [],
    acreedor: [],
    grupo_compras: [],
    indicador_abc: [],
    segmento: [],
    subsegmento: [],
    familia: [],
    gnombre: [],
    pnombre: [],
}
